import types from './types';
import { setLoanErroPopup } from './../api'
function formatNumber(numberVal) {
  let numberValString = numberVal.toString();
  if (numberVal) {
    var numArr = numberValString.split('.');
    numberValString = numArr[0];
    var result = '';
    while (numberValString.length > 3) {
      result = ',' + numberValString.slice(-3) + result;
      numberValString = numberValString.slice(0, numberValString.length - 3);
    }
    if (numberValString) {
      result = numberValString + result;
    }
    result = numArr[1] ? result + '.' + numArr[1] : result;
    return result;
  }
  return 0;
}

const mutations = {
  [types.DASHBOARD_HOME_DATA_CHANGED](state, data) {
    if (data) {
      state.userInfo = data.userInfo;
      state.contactInfo = data.contactInfo;
      state.isNoApplication = !data.contactInfo.hasApplications;
      state.isUserGuide = state.userInfo.isFirstTimeLoginNCA;
      state.retAdobeLMSUrl = data.retAdobeLMSUrl;
      state.retProgramEligibilityUrls = data.retProgramEligibilityUrls;
      let ua = navigator.userAgent;
      let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
      let isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
      let isAndroid = ua.match(/(Android)\s+([\d.]+)/);
      let isMobile = isIphone || isAndroid;
      state.isMobile = isMobile && isMobile.length > 0;
      if (!state.isUserGuide || isMobile) {
        let loanErrorPopup = { isShow: false };
        if (data.contactInfo.isDACALoanAvailable) {
          loanErrorPopup = setLoanErroPopup(data.program.viewLoans)
        }
        if (!loanErrorPopup.isShow) {
          state.isCustomPopup = data.contactInfo.isCOVIDAvailable || data.contactInfo.isDACAGrantAvailable || data.contactInfo.isDACALoanAvailable || data.contactInfo.isIFRPAvailable || data.contactInfo.isIFRPLoanAvailable || data.contactInfo.isMIJAGrantAvailable;
        }
      }

      data.pendingApplications.forEach((pendingApplication) => {
        if (pendingApplication.application.submittedTime) {
          pendingApplication.application.submittedTime = pendingApplication.application.submittedTime;
        }
        state.dashboardHomeData.pendingApps.push(pendingApplication);
      });

      if (data.loanProductInfos && data.loanProductInfos.length > 0) {
        data.loanProductInfos.forEach((loanProductInfo) => {
          if (loanProductInfo.sourceParamter && (loanProductInfo.sourceParamter === 'DACAPreAppGrant' || loanProductInfo.sourceParamter === 'DACA-OCEIA')) {
            state.dacaGrantBtnText = loanProductInfo.displayName;
          }
          if (loanProductInfo.sourceParamter && (loanProductInfo.sourceParamter === 'DACALoan' || loanProductInfo.sourceParamter === 'DACA-Loan-OCEIA')) {
            state.dacaLoanBtnText = loanProductInfo.displayName;
          }
          if (loanProductInfo.sourceParamter && loanProductInfo.sourceParamter.startsWith('IFRP') && loanProductInfo.sourceParamter !== 'IFRP-Loan') {
            state.ifrpBtnText = loanProductInfo.displayName;
          }
          if (loanProductInfo.sourceParamter && loanProductInfo.sourceParamter === 'IFRP-Loan') {
            state.ifrpLoanBtnText = loanProductInfo.displayName;
          }
          if (loanProductInfo.sourceParamter && loanProductInfo.sourceParamter === 'Immigration-Grant-OCEIA') {
            state.mijaGrantBtnText = loanProductInfo.displayName;
          }
        });
      }

      if (data.program.viewLoans && data.program.viewLoans.length > 0) {
        data.program.viewLoans.forEach((viewLoan) => {
          viewLoan.nextDueDate = viewLoan.nextDueDate;
          viewLoan.distributionDate = viewLoan.distributionDate;
          viewLoan.loanStartDate = viewLoan.loanStartDate;
          viewLoan.loanEndDate = viewLoan.loanEndDate;
          viewLoan.nextPaymentAmount = formatNumber(viewLoan.nextPaymentAmount);
          viewLoan.loanAmount = formatNumber(viewLoan.loanAmount);
          viewLoan.loanBalance = formatNumber(viewLoan.loanBalance);
          let totalAmount = 0;
          let totalPrincipal = 0;
          let totalFees = 0;
          let totalInterest = 0;
          if (viewLoan.loanPaymentTransactions && viewLoan.loanPaymentTransactions.length > 0) {
            viewLoan.loanPaymentTransactions.forEach((transaction) => {
              transaction.isFold = true;
              totalAmount += transaction.transactionAmount;
              totalPrincipal += transaction.principal;
              totalFees += transaction.fees;
              totalInterest += transaction.interest;
              const transactionDate = new Date(transaction.transactionDate);
              transaction.transactionDate = ((transactionDate.getMonth() > 8) ? (transactionDate.getMonth() + 1) : ('0' + (transactionDate.getMonth() + 1))) + '/' + ((transactionDate.getDate() > 9) ? transactionDate.getDate() : ('0' + transactionDate.getDate())) + '/' + transactionDate.getFullYear();
            });
          }
          viewLoan.totalAmount = formatNumber(totalAmount);
          viewLoan.totalPrincipal = formatNumber(totalPrincipal);
          viewLoan.totalFees = formatNumber(totalFees);
          viewLoan.totalInterest = formatNumber(totalInterest);

          let isActiveProgram = viewLoan.loanStatus.indexOf('Closed:') !== -1 ? false : viewLoan.loanStatus.indexOf('Active:') !== -1 || viewLoan.loanStatus.indexOf('Past Due:') !== -1 || viewLoan.loanStatus.indexOf('Charge Off') !== -1;
          if (viewLoan.loanStatus && isActiveProgram) {
            viewLoan.loanStatus = viewLoan.loanStatus.replace('Active:', '');
            viewLoan.loanStatus = viewLoan.loanStatus.replace('Past Due:', '');
            state.dashboardHomeData.program.activeProgram.viewLoans.push(viewLoan);
          } else {
            viewLoan.loanStatus = 'Closed';
            state.dashboardHomeData.program.closedProgram.viewLoans.push(viewLoan);
          }
        });
      }

      if (data.program.ViewScholarshipApplications && data.program.ViewScholarshipApplications.length > 0) {
        data.program.ViewScholarshipApplications.forEach((viewIFRP) => {
          if (viewIFRP.isActiveIFRP) {
            state.dashboardHomeData.program.activeProgram.viewIFRPs.push(viewIFRP);
          } else {
            state.dashboardHomeData.program.closedProgram.viewIFRPs.push(viewIFRP);
          }
        });
      }
    }
    state.isLoading = false;
  },
  [types.CURRENT_TAB_CHANGED](state, tab) {
    state.currentTab = tab;
  },
  [types.SHOW_PHONE_MENU_CHANGED](state, flag) {
    state.showPhoneMenu = flag;
  },
  [types.IS_USER_GUIDE_CHANGED](state, flag) {
    state.isUserGuide = flag;
  },
  [types.IS_CUSTOM_POPUP_CHANGED](state, flag) {
    state.isCustomPopup = flag;
  },
  [types.IS_POPUP_STEP_CHANGED](state, flag) {
    state.popupStep = flag;
  },
  [types.IS_BUTTON_SOURCE_CHANGED](state, flag) {
    state.checkedBtnSource = flag;
  },
  [types.SHOW_LOANS_POPUP](state, data) {
    state.showLoansPopup = data;
  },
  [types.TIME_OUT](state, flag) {
    state.timeOut = flag;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/mutations.js